export default {
  error: null,
  authenticationPending: true,
  loading: false,
  resetPasswordSent: false,
  role: null
}
